import React, { Suspense } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Loading from './components/loading/Loading';
import ProtectedRoute from './components/ProtectedRoute';

const HomePage = React.lazy(() => import('./pages/home'));
const SupportPage = React.lazy(() => import('./pages/support'));
const ErrorPage = React.lazy(() => import('./pages/error'));
const SSOCallback = React.lazy(() => import('./pages/auth'));

function AppRoutes() {
  return (
    <React.StrictMode>
      <Suspense fallback={<Loading tip="Loading Components..." />}>
        <Routes>
          {/* SSO Callback - handles the redirect from IDP */}
          <Route path="/" element={<SSOCallback />} />

          {/* Protected routes */}
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/support"
            element={
              <ProtectedRoute>
                <SupportPage />
              </ProtectedRoute>
            }
          />

          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/home" replace />} />
        </Routes>
      </Suspense>
    </React.StrictMode>
  );
}

export default AppRoutes;
